export default {
  'site.title': 'SuperAcme Mall',
  'about.title': 'About SuperAcme',
  'page.name.wifi': 'How to distinguish between 5G and 2.4G Wi-Fi',
  // 请求配置
  requestConfiguration: 'Request configuration',
  // 处理审批的审查和批准
  reviewAndApproval: 'Review and approval of processing',
  // 取消
  cancel: 'Cancel',
  // 确定
  ok: 'OK',
  // 您确定要注销您的帐户吗？
  confirmDeregisterAccount: 'Deregister',
  // 稍后
  later: 'Later',
  // 您确定要删除组中的设备吗？
  confirmDeleteDevicesInGroup: 'Are you sure you want to delete the devices in the group',
  // 删除
  delete: 'Delete',
  // 编辑分组
  editGroup: 'Edit group',
  // 图标
  icon: 'Icon',
  // 标题
  title: 'Title',
  // 副标题
  subtitle: 'Subtitle',
  // 按钮操作点
  buttonActionPoint: 'Button action point',
  // 全屏
  fullScreen: 'Full screen',

  // 返回
  back: 'Back',

  // 模式
  mode: 'Mode',
  // 你可以配置一张图片。
  configureImage: 'You can configure an image.',
  // 获取数据失败。
  fetchDataFailed: 'Data acquisition failed',
  // 检查网络并点击重新加载。
  checkNetworkAndReload: 'Please check the network and try again',
  // 请检查输入错误
  needCheckError: 'Please Check input error',
  // 点击重试
  tapToRetry: 'Retry',
  // 没有数据
  noData: 'No data',
  // 正在加载...
  loading: 'Loading',
  // 不要使用
  doNotUse: 'Do not use',
  // 缺失参数
  missingParameters: 'Missing parameters',
  // 已过期
  expired: 'Expired',
  // 无效
  invalid: 'Invalid',
  // 无效请求
  invalidRequest: 'Invalid request',
  // 没有权限
  noPermission: 'No permission',
  // 付款
  payment: 'payment',
  // 待付款
  pendingPayment: 'Pending payment',
  // 支付成功
  paymentSuccessful: 'Successful',
  // 支付失败
  paymentFailed: 'Payment failed',
  // 激活中
  activating: 'Activating',
  // 通过使用递归方法获取目录中的所有文件的路径
  getPathsOfAllFiles:
    'Obtain the paths of all files in the directory by using the recursive method',
  // 在文件中提取所有汉字字符串
  extractChineseStrings: 'Extract all Chinese character strings in the files',
  // 去重数据结构
  deduplicateDataStructures: 'Deduplicate data structures',
  // 创建或清除输出文件
  createOrClearOutputFiles: 'Create or clear output files',
  // 例如，搜索目录中的所有文件
  exampleSearchFiles: 'For example, to search all the files in a directory',
  // 注销帐户
  deregisterAccount: 'Delete Account',
  // 在注销帐户之前三思而后行。
  thinkBeforeDeregister: 'Think twice before you deregister your account.',
  // 此操作不可逆转。
  irreversibleAction: 'This action is irreversible.',
  // 谨慎操作。
  proceedWithCaution: 'Proceed with caution.',
  // 所有权益在帐户注销后清除。
  benefitsCleared: 'All benefits are cleared after an account is deregistered.',
  // 在您注销帐户后，
  afterDeregisterAccount: 'After you deregister your account,',
  // 您通过使用此帐户获得的权限、权益和功能立即失效，
  benefitsAndFeaturesInvalid:
    'your permissions, benefits, and features obtained by using this account become invalid immediately, including but are not limited to the cloud storage plans, algorithms, and memberships you purchased or were gifted.',
  // 如果您仍在使用CiNMOORE产品，
  stillUsingCiNMOOREProducts: 'If you are still using products, Do not deregister your account.',
  // 帐户责任
  accountResponsibilities: 'Account responsibilities',
  // 帐户的删除不免除您对使用帐户进行的行为的责任或减少您的责任。
  accountDeletionResponsibilities:
    'The deletion of your account does not exempt you from or lessen your responsibilities for the behavior you conducted by using the account.',
  // 在您注销帐户后，关联的数据被清除，无法恢复
  associatedDataCleared:
    'After you deregister your account, the associated data is cleared and cannot be restored, the device cannot function properly.',
  // 上一个
  previous: 'Previous',
  // 系统错误
  systemError: 'System error',
  // 评价我们
  rateUs: 'Rate us',
  // 输入有效的电话号码
  enterValidPhoneNumber: 'Enter a valid phone number',
  // 提交成功
  submissionSuccessful: 'Submitted',
  // 提交失败
  submissionFailed: 'Submission failed',
  // 重试
  retry: 'Retry',
  // 评价
  review: 'Review',
  // 输入您的建议
  enterYourSuggestion: 'Enter your suggestion',
  // 联系信息
  contactInformation: 'Contact Information',
  // 输入电话号码
  enterPhoneNumber: 'Enter a phone number',
  // CiNMOORE产品试用
  cinmooreProductTrial: 'CiNMOORE product trial use',
  // 悟空简介
  wukongIntroduction: 'Introduction to Wukong',
  // 产品图片
  productImage: 'Product image',
  // 遵循将传统文化与技术和艺术相融合的设计原则，
  adheringToDesignPrinciple:
    'Adhering to the design principle of integrating traditional culture with technology and art,',
  // 产品的设计看起来像
  productDesignedToLookLike:
    'the product is designed to look like Sun Wukong’s eyes and the Golden Hoop',
  //  如果您的体验报告优秀，您将被授予我们的惊喜奖品。
  excellentExperienceReport:
    'If your experience report is excellent, you’ll be awarded our surprise prizes.',
  // 申请已提交
  applicationSubmitted: 'Application submitted',
  // 申请
  apply: 'Apply',

  // 输入的名称不能包含表情
  emojiValidation: 'The name cannot contain emojis.',

  // 提交
  submit: 'submit',
  // 提交材料
  submitMaterials: 'Submit materials',
  // 手机号码
  mobileNumber: 'Mobile Number',
  // 微信ID
  weChatID: 'WeChat ID',
  // 输入一个微信ID
  enterWeChatID: 'Enter a WeChat ID',
  // 反馈
  feedback: 'Feedback',
  // 微信官方帐号图像
  weChatOfficialAccountImage: 'WeChat official account image',
  // 关注CiNMOORE的微信官方帐号以提交您的反馈
  followWeChatOfficialAccount:
    'Follow the WeChat official account of CiNMOORE to submit your feedback',
  // 输入一个新的群组名称
  enterNewGroupName: 'Enter a new group name',
  // 群组名称太长
  groupNameTooLong: 'The group name is too long.',
  // 重命名群组
  renameGroup: 'Rename group',
  // 导入设备
  importDevice: 'Import',
  // 重命名
  rename: 'Rename',
  // 您确定要删除群组吗？
  confirmDeleteGroup: 'Are you sure you want to delete the group?',
  // 重命名
  renamed: 'Renamed',
  // 必须指定名称
  nameMustBeSpecified: 'A name must be specified.',
  // 添加群组
  addGroup: 'Add group',
  // 输入群组名称
  enterGroupName: 'Enter a group name',
  //  设备
  devices: 'devices',

  // 设置充值引导
  setRechargeGuide: 'Device reset boot',

  // 您有神眸权益(原云存套餐)可转移
  packageCanTransfer:
    'You have Meari rights (original cloud storage package) that can be transferred',

  // 注销账号后，您对应权限和服务将失效
  cancelAccountService:
    'After cancelling your account, your corresponding permissions and services will be invalidated',

  // 存在已绑定设备，请删除后再试
  boundDelete: 'There are devices already bound, please delete them and try again',

  // 去转移
  goToTransfer: 'Go to transfer',

  // 忍痛注销
  reluctantlyCancel: 'Reluctantly cancel',

  share: 'Share',

  // 已添加
  added: 'Added',
  // 管理群组
  manageGroup: 'Manage group',
  // 设备图像
  deviceImage: 'Device image',
  // 选择一个设备
  selectADevice: 'Select a device',
  // 已导入
  imported: 'Imported',
  // 第一步
  stepOne: 'Step one',
  // 第二步
  stepTwo: 'Step two',
  // 选择要导入的设备
  selectDeviceToImport: 'Select a device to import',
  // 故障排除
  troubleshooting: 'Troubleshooting',
  // 步骤 1
  step1: 'Step 1',
  // 重新启动设备
  restartDevice: 'Restart the device',
  // 向左滑动以检查每个型号的电源按钮位置
  swipeLeftToCheckPowerButton: 'Swipe left to check where the power button of each model is.',
  // 检查设备是否发出语音提示，提醒设备已启动
  checkVoiceAnnouncement:
    'Check whether the device gives a voice announcement reminding that the device has started.',
  // 如果没有语音提示，请使用充电器为设备充电约
  noVoiceAnnouncement:
    'If no voice announcement is given, reminding that the device has started. use the charger to charge the device for about ten minutes. The device should give a voice announcement.',
  // 分钟。设备应该发出语音提示。
  minutesToGetVoiceAnnouncement: '',
  // 否则，请尝试重新启动您的路由器。
  tryRestartingRouter: 'Otherwise, try restarting your router.',
  // 个人信息
  personalInformation: 'Personal information',

  // 连续短按2下,听到设备语音播报重置成功
  pressTwiceToReset:
    'Press twice in quick succession to hear the device voice announcement that the reset is successful.',

  // 连续短按2下,唤醒设备
  pressTwiceToWakeUp: 'Press twice in quick succession to wake up the device.',

  // 双击RST键,听到设备语音播报重置成功
  doubleClickRST:
    'Double-click the RST button to hear the device voice announcement that the reset is successful.',

  pressWakeUp: 'Press and hold the power button for about 3 seconds to wake up the device',

  // 以具体产品为准,图仅供部分产品参考
  specificProductReference: 'Refer to the specific product, the image is for reference only',

  // 头像
  avatar: 'Avatar',
  // 用户名
  username: 'User Name',
  // 电子邮件
  email: 'Email',
  // 更改密码
  changePassword: 'Change Password',
  // 有绑定设备。
  boundDevices: 'There are bound devices.Unbind the devices and try again.',
  // 网络错误
  networkError: 'Network error',
  // 稍后重试
  tryAgainLater: 'Try again later.',
  // 输入用户名
  enterUsername: 'Enter your username',
  // 用户名太长
  usernameTooLong: 'Please enter a username of no more than 24 characters.',
  // 修改成功
  modificationSuccessful: 'Modification successful',
  // 修改失败
  modificationFailed: 'Modification failed',
  // 保存
  save: 'Save',
  // 绑定的手机号码
  boundMobileNumber: 'Bound mobile number',
  // 未绑定手机号码
  noBoundMobileNumber: 'No mobile number bound',
  // 更改手机号码
  changeMobileNumber: 'Change mobile number',
  // 所有的共享权限都被取消了。
  allSharedPermissionsCanceled: 'All the shared permissions are canceled.',
  // SuperACME
  superACME: 'SuperACME',
  // Meari
  meari: 'Meari',

  startShareDevice: 'Click the top right corner to share the device',
  // Jijia
  jijia: 'Jijia',
  // 取消所有的共享权限吗？
  confirmCancelAllSharedPermissions: 'Are you sure you want to cancel all the shared permissions?',
  // 取消全部
  cancelAll: 'Cancel all',
  // 共享给
  sharedWith: 'Shared with',
  // 的权限
  permissions: "'s permissions",
  // 修改权限
  changePermissions: 'Change permissions',
  // 您确定要取消
  confirmCancelSharedPermissions: "Are you sure you want to cancel 's shared permissions?",
  // 取消共享
  cancelSharing: 'Cancel sharing',
  // 允许控制
  allowControl: 'Allow control',
  // 可以查看设备信息并控制设备。
  canViewAndControlDevices: 'Can view device information and control devices.',
  // 仅查看
  viewOnly: 'View only',

  // 可以查看设备信息但不能控制设备。
  canViewDeviceInfo: 'Can view device information but cannot control devices.',

  canViewDeviceInfoX: 'You can view device information, but only control some of its functions',

  // 无法控制设备
  cannotControlDevices: 'Cannot control devices',
  // 我的共享
  mySharing: 'My sharing',
  // 请设置Ta的权限
  settingAuth: 'Please set permissions for them.',
  // 网络错误。稍后再试。
  networkErrorTryAgain: 'Network error. Try again later.',
  // 共享设置
  sharingSettings: 'Sharing settings',
  // 下一步
  next: 'Next',
  // 生成QR码的时间
  qrCodeGenerationTime: 'QR code generation time:',
  // 有效期
  validityPeriod: ' valid for',
  // 至
  to: 'to',
  // 分钟
  minutes: 'minutes',
  // 仅限单次使用
  forSingleUseOnly: 'For single use only',
  // 返回首页
  returnToHomePage: '返回首页',
  // 如果QR码已使用或过期，管理员应该分享 一个新的QR码。

  // 一个新的QR码。
  shareNewQRCode: 'If the QR code has been expired, the administrator should share a new QR code.',
  shareNewQRCodeNew:
    'If it has been used or expired, the administrator needs to generate a new shared QR code.',
  // 前往手机应用商店下载CiNMOORE
  goToAppStore:
    'Please download the Cinmoore app from app store. On the main page, click the "+" in the top right corner and scan QR code.',
  // CiNMOORE Smart
  cinmooreSmart: 'CiNMOORE Smart',
  // 步骤
  step: 'Step',
  // 这个文件
  thisFile: 'This file',
  // 自动生成
  automaticallyGenerated: 'Automatically generated',
  // 不要修改
  doNotModify: 'Do not modify',
  // API
  api: 'API',
  // 查看CiNMOORE产品的请求类型
  reviewCinmooreProductRequestType: 'Review CiNMOORE products’s Request type',
  // 类别
  category: 'Category',
  // 售后活动
  afterSalesActivities: 'After-sales Activities',
  // 请求头
  requestHeader: 'Request Header',
  // 更新时间
  updateTime: 'Update Time',
  // 星级数量
  numberOfStars: 'Number of Stars',
  // 建议
  suggestion: 'Suggestion',
  // 响应类型
  responseType: 'Response type',
  // 查询用户是否之前申请过CiNMOORE产品的试用
  queryUserAppliedForTrial:
    'Query whether the user applied for a CiNMOORE product trial use before',
  // 之前申请过CiNMOORE产品的试用
  appliedForCiNMOORETrialBefore: 'Applied for a CiNMOORE product trial use before',
  // 否
  no: 'No',
  // 申请时间
  applicationTime: 'Application Time',
  // 时间戳（毫秒）
  timestampInMilliseconds: 'Timestamp in milliseconds',
  // 申请CiNMOORE产品的试用
  applyForCiNMOORETrial: 'Apply for CiNMOORE product trial use',
  // 上传头像
  uploadAvatar: 'Upload avatar',
  // 登录后使用的API
  apisUsedAfterLogin: 'APIs used after login',
  // 编码的图像数据
  encodedImageData: 'Encoded image data',
  // 绑定用户可以更改绑定的手机号码和电子邮件地址。
  changeBoundMobileAndEmail: 'The bound user can change the bound mobile number and email address.',
  // 电话号码的区号
  areaCodeOfPhoneNumber: 'Area code of telephone number',
  // 中国大陆用户可以使用以下之一。
  chineseMainlandUsersOptions: 'Users in the Chinese mainland can use one of the following.',
  // 指定这个或电子邮件地址的其中之一
  specifyEitherThisOrEmail: 'Specify either this or an email address',
  // 当选中时
  whenSelected: 'When selected',
  // 必填字段
  requiredField: 'Required field',
  // 指定这个或手机号码的其中之一
  specifyEitherThisOrMobile: 'Specify either this or a mobile number',
  // 用户注销
  userDeregistration: 'User Deregistration',
  // 注销
  logout: 'Log out',
  // 获取用户操作记录
  obtainUserOperationRecords: 'Obtain user operation records',
  // 开始时间
  startTime: 'Start time',
  // 格式
  format: 'Format',
  // 结束时间
  endTime: 'End time',
  // 页大小
  pageSize: 'Page size',
  // 每页的条目数
  entriesPerPage: 'Number of entries per page',
  // 数据
  data: 'Data',
  // 当前操作名称
  currentOperationName: 'Current operation name',
  // 当前操作类型
  currentOperationType: 'Current operation type',
  // 客户端
  client: 'Client',
  // 操作时间
  operationTime: 'Operation time',
  // 重置密码
  resetPassword: 'Reset password',
  // 当前密码
  currentPassword: 'Current password',
  // 新密码
  newPassword: 'New password',
  // 是否启用设备绑定
  enableDeviceBinding: 'Enable device binding',
  // 启用
  enable: 'Enable',
  // 关闭
  close: 'Close',
  // 获取已绑定设备的列表
  obtainBoundDevicesList: 'Obtain the list of bounded devices',
  // 云平台上的唯一用户
  uniqueUserOnCloudPlatform: 'Unique user on cloud platform',
  // 唯一设备
  uniqueDevice: 'Unique device',
  // 设备名称
  deviceName: 'Device name',
  // 用户解绑定的设备
  deviceUnboundByUser: 'Device unbound by the user',
  // 可以一次指定多个唯一设备
  canSpecifyMultipleUniqueDevices: 'Can specify multiple unique devices at a time',
  // 基本用户信息
  basicUserInfo: 'Basic user information',
  // 用户头像
  userAvatar: 'User avatar',
  // 有限的访问时间
  limitedVisitTime: 'Limited visit time',
  // 用户性别
  userGender: 'User gender',
  // 出生日期
  dateOfBirth: 'Date of birth',
  // 用户昵称
  userNickname: 'User nickname',
  // 修改基本用户信息（昵称和出生日期）
  modifyBasicUserInfo: 'Modify basic user information (nickname and date of birth)',

  // 选择转出套餐
  transferListTitle: 'todo:',

  // 添加设备组
  addDeviceGroup: 'Add group',
  // 设备组
  deviceGroup: 'Device group',
  // 组名
  groupName: 'Group name',
  // 所有组和设备
  allGroupsAndDevices: 'All groups and devices',
  // 默认组
  defaultGroup: 'Default group',

  // 设备组
  noDeviceGroup: 'No Devices in the group',

  // 设备
  device: 'Device',

  // 云端唯一标识
  uniqueIDOnCloud: 'Unique ID on cloud',

  // 设备昵称
  deviceNickname: 'Device nickname',

  // 设备状态
  deviceStatus: 'Device status',

  // 未激活
  notActivated: 'Not activated',

  // 在线
  online: 'Online',

  // 离线
  offline: 'Offline',

  // 已禁用
  disabled: 'Disabled',

  // 产品
  product: 'Product',

  // 设备号
  deviceNumber: 'Device No.',

  // 共享设备
  sharedDevices: 'Shared devices',

  // 我绑定的设备
  devicesBoundByMe: 'Devices bound by me',

  // 如果设备被朋友共享，显示朋友的用户名
  sharedByFriend: 'If the device is shared by a friend, it indicates the username of the friend.',

  // 共享设备权限
  shareDevicePermissions: 'Share device permissions',

  // 查看权限
  view: 'View',

  // 控制权限
  control: 'Control',

  // 云存储激活标识
  cloudStorageActivationIdentifier: 'Cloud storage activation identifier',

  // 已激活
  activated: 'Activated',

  // 开/关
  onOff: 'On/Off',

  // 关闭
  off: 'Off',

  // 开启
  on: 'On',

  // 扫描二维码绑定设备
  scanQRCodeToBindDevice: 'Scan QR Code to bind device',

  // 设备共享
  deviceSharing: 'Device Sharing',

  // 通过调用阿里巴巴云的API生成
  generatedByAPICall: 'Generated by calling an API of Alibaba Cloud',

  // 添加设备到组
  addDeviceToGroup: 'Add device to group',

  // 数组元素的数量至少应该是
  numberOfArrayElements: 'The number of array elements should be at least.',

  // 取消设备共享
  cancelDeviceSharing: 'Cancel device sharing',

  // 取消与用户的共享关系
  cancelSharingWithUser: 'Cancel sharing with user',

  // 绑定关系
  bindingRelationship: 'Binding relationship',

  // 删除组
  deleteGroup: 'Delete group',

  // 删除组中的设备
  deleteDevicesInTheGroup: 'Delete the devices in the group',

  // 我的设备共享统计
  myDeviceSharingStats: 'My device sharing stats',

  // 共享设备数量
  numberOfSharedDevices: 'Number of shared devices',

  // 我共享给的用户数量
  numberOfUsersISharedWith: 'Number of users I shared with',

  // 获取设备共享数据
  obtainDeviceSharingData: 'Obtain device sharing data',

  // 共享设备的用户名
  usernameOfSharedDevice: 'Username of who shared the device',

  // 共享时间
  sharedAt: 'Shared at',

  // 权限修改时间
  permissionModifiedAt: 'Permission modified at',

  // 获取组内设备列表
  obtainDeviceListInGroup: 'Obtain the list of devices in the group',

  // 云端设备的唯一标识
  uniqueIDOnCloudOfDevice: 'The unique ID of the device on the cloud.',

  // 设备图片URL
  deviceImageURL: 'Device image URL',

  // 设备类型
  deviceType: 'Device type',

  // 共享
  share: 'Share',

  // 由我绑定
  boundByMe: 'Bound by me',

  // 创建时间
  createdAt: 'Created at',

  // 修改时间
  modifiedAt: 'Modified at',

  // 获取组列表
  obtainGroupList: 'Obtain the group list',

  // 修改共享给用户的权限
  modifyPermissionsSharedWithUser: 'Modify permissions shared with user',

  // 发送阿里巴巴云绑定结果到服务器
  sendAlibabaCloudBindingResultsToServer: 'Send Alibaba Cloud binding results to server',

  // 失败
  failed: 'Failed',

  // 分组排序
  groupSorting: 'Group sorting',

  // 排序后的序号
  noAfterSorting: 'No. after sorting',

  // 通过二维码共享设备
  shareDeviceViaQRCode: 'Share device via QR code',

  // 服务器上的共享记录
  sharingRecordsOnServer: 'Sharing records on server',

  // 权限
  permission: 'Permission',

  // 方法不存在
  methodNonexistent: 'Method nonexistent',

  // 选项不存在
  optionNonexistent: 'Option nonexistent',

  // 响应
  response: 'Response',

  // 请求失败
  requestFailed: 'Request failed',

  // 错误
  error: 'Error',

  // 解析返回结果时发生错误
  errorOccurredDuringParsing: 'An error occurred during parsing of returned results.',

  // 我已阅读并同意云存储服务协议
  readAndAgreed: 'I have read and agreed',

  // 我已阅读并同意云存储服务协议
  cloudStorageServiceAgreement: 'Cloud Storage Service Agreement',

  // 确认支付状态
  confirmPaymentStatus: 'Confirm payment status',

  // 支付完成
  paymentComplete: 'Payment complete',

  // 确定要取消共享权限吗？
  areYouSureToCancelSharedPermission: 'Are you sure you want to cancel the shared permission?',

  // 支付初始化失败
  failedToInitiatePayment: 'Failed to initiate a payment',

  // 检查是否安装了微信
  checkWeChatInstalled: 'Check whether WeChat is installed.',

  // 重新发起支付或前往订单页面查看订单详情
  reinitiatePaymentOrGoToOrdersPage:
    'Payment failed, Reinitiate a payment or go to the orders page to view order details.',

  // 选择支付方式
  selectPaymentMethod: 'Select a payment method',

  // 微信支付
  weChatPay: 'WeChat Pay',

  // 支付宝支付
  alipay: 'Alipay',

  // 您有一个待支付的订单
  orderPendingPayment: 'You have an order pending payment. Confirm payment status.',

  // 更智能的算法
  moreIntelligentWithAlgorithms: 'More intelligent with algorithms',

  // 运动检测
  movementDetection: 'Movement detection',

  // 入侵检测
  intrusion: 'Intrusion',

  // 镜头被遮挡
  lensCovered: 'Lens covered',

  // 安全报告
  securityReport: 'Security report',

  // 摄像头被遮挡
  cameraCovered: 'Camera covered',

  // 区域入侵
  zoneIntrusion: 'Zone intrusion',

  // 电池电量
  batteryLevel: 'Battery level',

  // 电量使用场景
  batteryUsage: 'Battery usage scenarios',

  // 电池电量消耗越快
  fasterBatteryConsumption: 'the battery is used, the more battery power is consumed.',

  // 次
  times: 'times',

  // CiNMOORE 报告
  ciNMOOREReport: 'CiNMOORE report',

  // 7天检测数据
  sevenDayDetectionData: '7-day detection data',

  // 7天检测趋势
  sevenDayDetectionTrend: '7-day detection trend',

  // 7天电池电量统计
  sevenDayBatteryLevelStats: '7-day battery level stats',

  // 非会员
  nonMember: 'Non-member',

  // 会员优惠
  commodityDiscountsForMembers: 'Commodity discounts for members',

  // 电池使用频率越高，电量消耗越多
  moreFrequentlyBatteryUsed:
    'The more frequently the battery is used, the more battery power is consumed.',

  // 云存储计划
  cloudStoragePlan: 'Cloud storage plan',

  // 算法计划
  algorithmPlan: 'Algorithm plan',

  // 检查是否安装了支付宝
  checkAlipayInstalled: 'Check whether Alipay is installed.',

  // 选择商品
  selectCommodity: 'Select a commodity',

  // 选中复选框确认同意云存储服务协议，然后结算支付
  selectCheckboxToConfirmAgreement:
    'Select the checkbox to confirm that you agree to the Cloud Storage Service Agreement and then settle the payment.',

  // 提交订单失败
  failedToSubmitOrder: 'Failed to submit the order',

  // 没有可用设备
  noAvailableDevice: 'No available device, Bind a device and try again.',

  // 云服务
  cloudService: 'Cloud service',

  // 扣除 x 元
  xYuanDeducted: 'deducted',

  // 货币
  currency: '$',

  // 免费
  free: 'Free',

  // 计划已生效
  planHasTakenEffect: 'The plan has taken effect.',

  // 计划类型
  planType: 'Plan type',

  // 生效日期
  effectiveDate: 'Effective date',

  // 预期生效日期
  expectedEffectiveDate: 'Expected effective date',

  // 计划规格
  planSpecification: 'Plan specification',

  // 使用状态
  statusOfUse: 'Status of use',

  // 已生效
  effective: 'Effective',

  // 立即生效
  toBeEffective: 'To be effective',

  // 是否立即生效
  whetherTakeEffectNow: 'Whether take effect now',

  // 立即生效
  takeEffectNow: 'Take effect now',

  // - 购买
  buy: 'Buy',

  // 云存储
  cloudStorage: 'Cloud storage',

  // 全流程数据加密
  fullProcessDataEncryption: 'Full-process data encryption',

  // 保护隐私
  protectPrivacy: 'Protect privacy',

  // 安全云存储
  secureCloudStorage: 'Secure cloud storage',

  // 视频的安全云存储
  secureCloudStorageOfVideos: 'Secure cloud storage of videos',

  // 小时待机
  hourStandby: '-hour standby',

  // 自动上传
  uploadAutomatically: 'Upload automatically',

  // 无风险
  noRisk: 'No risk',

  // 即使设备离线，也可随时查看历史视频
  viewHistoricalVideosOffline:
    'You can view historical videos any time even when the device is offline.',

  // 存储空间
  storageSpace: 'Storage space',

  // 支持的
  supported: 'Supported',

  // 可选的7天云卷存储
  optionalSevenDayCloudRollStorage: 'Optional 7-day cloud roll storage',

  // 了解更多 CiNMOORE 产品
  learnAboutMoreCiNMOOREProducts: 'Learn about more CiNMOORE products',

  // 京东
  jdDotCom: 'JD.com',

  // 天猫
  tmall: 'Tmall',

  // 会员到期日期
  membershipExpiryDate: 'Membership expiry date',

  // 成为会员
  becomeAMember: 'Become a member',

  // 享受更多优惠
  enjoyMoreBenefits: 'Enjoy more benefits',

  // 更多关于会员中心
  moreAboutMemberCenter: 'More about Member Center',

  // - 加速播放
  amplifiedSpeedPlay: 'Amplified-speed play',

  // - 人体检测
  humanDetection: 'Human detection',

  // - 移动侦测
  motionDetection: 'Motion detection',

  // - 云存储功能
  cloudStorageFeature: 'Cloud storage feature',

  // CiNMOORE 产品
  ciNMOOREProducts: 'CiNMOORE products',

  // 查看详情
  viewDetails: 'View details',

  // 即将推出，敬请关注
  comingSoonStayTuned: 'Coming soon, stay tuned.',

  // 流量
  traffic: 'Traffic',

  // Wi-Fi 网络
  wiFiNetwork: 'Wi-Fi network',

  // 方便快捷
  convenientAndFast: 'Convenient and fast',

  // 报警事件会自动上传到云端，您可以查看历史报警视频，无需担心因内存卡损坏而导致数据丢失
  alarmEventsUploadedToCloud:
    'Alarm events are automatically uploaded to the cloud. You can view historical alarm videos without worrying about data loss caused by memory card damage.',

  // - 提供一周、一个月和一年的计划
  oneWeekOneMonthOneYearPlans:
    '3-day, One-week, one-month, and one-year plans are available. Unlimited storage capacity.',

  // 无限存储容量
  unlimitedStorageCapacity: 'Unlimited storage capacity',

  // 提示
  prompt: 'Prompt',

  // 云存储容量可能在不同时间段有所变化
  cloudStorageCapacityMayVary: 'Cloud storage capacity may vary in different time periods.',

  // 商城
  mall: 'Mall',

  // 输入密码
  enterPassword: 'Enter your password',

  // 登录
  login: 'Login',

  // 账户
  account: 'Account',

  // 输入手机号码或电子邮件地址
  enterMobileNumberOrEmailAddress: 'Enter your mobile number or email address',

  // 密码
  password: 'Password',

  // 立即登录
  logInNow: 'Log in now',

  // 忘记密码
  forgotPassword: 'Forgot password',

  // 注册
  register: 'Register',

  // 智能分析
  smartAnalysis: 'Smart analysis',

  // 云
  cloud: 'Cloud',

  // AI 算法
  aiAlgorithms: 'AI algorithms',

  // 准确识别人类
  accurateIdentificationOfHumans: 'Accurate identification of humans',

  // 车辆
  vehicles: 'Vehicles',

  // 宠物
  pets: 'Pets',

  // 人/车/宠/包裹
  humanVehiclePetParcel: 'Human/Vehicle/Pet/Parcel',

  // 订单列表
  orderList: 'Order list',

  // 一个月
  oneMonth: 'One month',

  // 一年
  oneYear: 'One year',

  // 一周
  oneWeek: 'One week',

  // 已完成
  completed: 'Completed',

  // 已取消
  canceled: 'Canceled',

  // 订单号
  orderNumber: 'Order No.',

  // 我的订单
  myOrders: 'My orders',

  // 一个季度
  oneQuarter: 'One quarter',

  // 支付订单
  payForTheOrder: 'Pay for the order',

  // 总计
  total: 'Total',

  // 您可以免费使用基本版云存储
  useBasicEditionOfCloudStorageForFree: 'You can use the basic edition of cloud storage for free.',

  // CiNMOORE提供的云存储基础版是免费的，您可以根据需要购买高级版云存储
  basicEditionOfCloudStorageProvidedByCiNMOOREForFree:
    'The basic edition of cloud storage is provided by CiNMOORE for free. You can buy the advanced edition of cloud storage as needed.',

  // 计划
  plan: 'Plan',

  // 不需要
  notRequired: 'Not required',

  // 当没有网络可用时，带宽可以像SIM卡一样方便使用
  andBandwidthCanBeAsEasyToUseAsASIMCardWhenNoNetworkIsAvailable:
    'and bandwidth can be as easy to use as a SIM card when no network is available',

  // 快速连接
  fastConnection: 'Fast connection',

  // 套餐
  package: 'Package',

  // 按需观看
  watchAsYouWant: 'Watch as you want',

  // 流量使用
  trafficUsage: 'Traffic usage',

  // 激活码不能为空
  activationCodeCannotBeEmpty: 'The activation code cannot be empty.',

  // 激活码过长
  activationCodeIsTooLong: 'The activation code is too long.',

  // 兑换计划
  redeemPlan: 'Redeem plan',

  // 输入激活码
  enterActivationCode: 'Enter an activation code',

  // -天有效期
  dayValidityPeriod: '-day validity period',

  // 无限流量
  unlimitedTraffic: 'Unlimited traffic',

  // 计划已兑换
  planRedeemed: 'Plan redeemed',

  // 或服务已生效
  orTheServiceIsEffective: 'or the service is effective',

  // 成功使用
  usedSuccessfully: 'Used successfully',
  // 优惠已生效
  benefitTakenEffect: 'The benefit has taken effect.',
  // 使用失败
  failedToUse: 'Failed to use',
  // 适用场景
  applicableScenarios: 'Applicable scenarios',
  // 休息室
  restRoom: 'Rest room',
  // 选择复选框以确认您已阅读并同意会员服务协议
  confirmMembershipAgreement:
    'Select the checkbox to confirm that you have read and agreed to the Membership Service Agreement',
  // 用人民币购买会员
  buyMembershipWithCNY: 'Buy membership with CNY',
  // 会员服务协议
  membershipServiceAgreement: 'Membership service agreement',
  // 没有可用设备
  noAvailableDevices: 'No available devices',
  // 您的免费额度已用完
  freeQuotaUsedUp: 'Your free quota is used up.',
  // 更多优惠
  moreBenefits: 'More benefits',
  // 剩余
  remaining: 'Remaining',
  // 立即使用
  useNow: 'Use now',
  // 选择设备
  selectDevice: 'Select device',
  // 会员中心
  memberCenter: 'Member center',
  // 使用人民币成为会员
  becomeMemberWithCNY: 'Become a member with CNY',
  // 享受更多免费优惠
  enjoyMoreFreeBenefits: 'Enjoy more free benefits',
  // 订单已取消
  orderCanceled: 'Order canceled',
  // 取消订单失败
  failedToCancelOrder: 'Failed to cancel the order',
  // 订单详情
  orderDetails: 'Order details',
  // 增值
  valueAdded: 'Value-added',
  // 已支付于
  paidAt: 'Paid at',
  // 取消订单
  cancelOrder: 'Cancel order',
  // 立即支付
  payNow: 'Pay now',
  // 支付
  pay: 'Pay',
  // 所有
  all: 'All',
  // 查看订单
  viewOrders: 'View orders',
  // 返回商城
  backToMall: 'Back to mall',
  // 已激活云存储
  cloudStorageActivated: 'Cloud storage activated',
  // 正在激活云存储
  activatingCloudStorage: 'Activating cloud storage',
  // 稍后检查云存储激活状态
  checkCloudStorageActivationStatusLater: 'Check the cloud storage activation status later',
  // 已发送验证码
  verificationCodeSent: 'A verification code has been sent.',
  // 立即检查
  checkNow: 'Check now',
  // 输入验证码
  enterVerificationCode: 'Enter the verification code',
  // 注册
  registered: 'Registered',
  // 注册失败
  registrationFailed: 'Registration failed',
  // 输入有效的手机号码或电子邮件地址
  enterValidMobileNumberOrEmailAddress: 'Enter a valid mobile number or email address',
  // 验证码
  verificationCode: 'Verification code',
  // 已有帐户
  alreadyHaveAnAccount: 'Already have an account',
  // 登录
  logIn: 'Log in',
  // 流量套餐
  trafficPlan: 'Traffic plan',
  // 设备列表
  deviceList: 'Device list',
  // 查看流量
  viewTraffic: 'View traffic',
  // 购买流量套餐
  buyTrafficPlan: 'Buy traffic plan',
  // 卡号
  cardNo: 'Card No.',
  // 套餐名称
  planName: 'Plan name',
  // 套餐时长
  planDuration: 'Plan duration',
  // 服务协议
  serviceAgreement: 'Service agreement',
  // 订阅服务
  subscribeService: 'Subscribe service',
  // 超大型云存储
  ultraLargeCloudStorage: 'Ultra-large cloud storage',
  // 更大的存储和更长的保留
  largerStorageAndLongerRetention: 'Larger storage and longer retention',
  // 准确识别
  accurateIdentification: 'Accurate identification',
  // 活动区域
  activityZone: 'Activity zone',
  // 请勿打扰
  doNotDisturb: 'Do not disturb',
  // 基础版
  basicEdition: 'Basic edition',
  // 高级版
  advancedEdition: 'Advanced edition',

  // 专业版
  professionalEdition: 'Professional edition',
  // 到期后手动续订
  manualRenewalUponExpiry: 'Manual renewal upon expiry',
  // 服务优势
  serviceBenefits: 'Service benefits',
  // 智能服务
  smartService: 'Smart service',
  // 我的优势
  myBenefits: 'My benefits',
  // 没有可用的服务计划
  noAvailableServicePlans: 'No available service plans',
  // 设置
  set: 'Set',
  // 查看优势
  viewBenefits: 'View benefits',
  // 转移成功
  transferSuccessful: '转移成功',
  // 订单模块
  orderModule: 'Order module',
  // 获取订单的支付状态
  obtainPaymentStatusOfOrder: 'Obtain the payment status of the order',
  // 在SuperACME云上的唯一订单
  uniqueOrderOnSuperACMECloud: 'Unique order on SuperACME cloud',
  // 第三方云存储已激活，但激活失败
  thirdPartyCloudStorageActivationFailed: 'Activation of third-party cloud storage failed',
  // 正在支付
  paying: 'Paying',
  // 已支付
  paid: 'Paid',
  // 订单类型
  orderType: 'Order type',
  // 获取用户的订单列表
  obtainUsersOrderList: "Obtain the user's order list",
  // 页码
  pageNo: 'Page No.',
  // 订单支付时间
  orderPaidAt: 'Order paid at',
  // 识别当前订单的支付方式
  identifyPaymentMethodOfCurrentOrder: 'Identifies the payment method of the current order',
  // 通过微信支付所需的字段
  fieldsRequiredForPaymentViaWeChatPay: 'Fields required for payment via WeChat Pay',
  // 支付系统的唯一标识符
  paymentSystemUniqueIdentifier: 'Unique identifier of payment system',
  // 客户使用此标识符和支付系统提供的x
  initiateThirdPartyPaymentLocally: 'Initiate a third-part payment locally',
  // 商户ID
  merchantID: 'Merchant ID',
  // 随机值
  randomValue: 'Random value',
  // 时间戳
  timestamp: 'Timestamp',
  // 签名
  signature: 'Signature',
  // 订单详细扩展字符串
  orderDetailsExtendedStrings: 'Order details extended strings',
  // 现在输入一个固定值
  enterFixedValueForNow: 'Enter a fixed value for now',
  // 获取设备的免费计划详情
  obtainDetailsOfFreePlansForDevice: 'Obtain the details of free plans for the device',
  // 云存储增值服务
  cloudStorageValueAddedServices: 'Cloud storage value-added services',
  // SuperACME云上的唯一设备
  uniqueDeviceOnSuperACMECloud: 'Unique device on SuperACME cloud',
  // 是否获得免费云存储计划
  haveFreeCloudStoragePlansBeenAwarded: 'Whether free cloud storage plans have been awarded',
  // 在视频云存储周期中覆盖的天数配置
  configurationOfCoveredDaysInVideoCloudStorageCycle:
    'Configuration of covered days in a video cloud storage cycle',
  // 单位
  unit: 'Unit',
  // 连续类型
  continuousType: 'Continuous type',
  // 事件类型
  eventType: 'Event type',
  // 云存储服务是否已过期
  isCloudStorageServiceExpired: 'Whether the cloud storage service has expired',
  // 获取免费云存储计划
  getFreeCloudStoragePlans: 'Get free cloud storage plans',
  // 现在不生效
  doNotTakeEffectNow: 'Do not take effect now',
  // 下订单并支付
  placeOrderAndPay: 'Place order and pay',
  // 计划ID
  planID: 'Plan ID',
  // 计划的购买金额
  purchaseAmountOfPlan: 'Purchase amount of the plan',
  // 此字段是下订单和支付所需的API
  thisFieldIsRequiredForPlacingAndPayingAnOrder:
    'This field is required by the API for placing and paying an order',
  // 查询云存储计划是否可购买
  queryWhetherCloudStoragePlanIsBuyable: 'Query whether a cloud storage plan is buyable',
  // 可购买
  buyable: 'Buyable',
  // 不可购买
  notBuyable: 'Not buyable',
  // 获取设备当前使用的计划详情
  obtainDetailsOfPlansCurrentlyUsedByDevice:
    'Obtain details of the plans currently used by a device',
  // 计划是否已启用
  isPlanEnabled: 'Whether the plan is enabled',
  // 获取云存储计划列表的设备
  obtainDevicesListOfCloudStoragePlans: "Obtain the device's list of cloud storage plans",
  // 有效
  valid: 'Valid',
  // 下订单
  placeOrder: 'Place order',
  // 云存储计划转移
  cloudStoragePlanTransfer: 'Cloud storage plan transfer',
  // 计划将从哪个设备转移
  deviceFromWhichPlanIsToBeTransferred: 'Device from which the plan is to be transferred',
  // 待转移的计划的订单
  orderOfPlanToBeTransferred: 'Order of the plan to be transferred',
  // 计划将转移到哪个设备
  deviceToWhichPlanIsToBeTransferred: 'Device to which the plan is to be transferred',
  // 是否立即使用
  whetherToUseNow: 'Whether to use now',

  // 检查设备是否有可用的免费云存储计划
  checkForFreeCloudStoragePlan:
    'Check whether any free cloud storage plan is available for the device',
  // 免费云存储计划立即生效
  freeCloudStoragePlansTakeEffectImmediately:
    'Specify that free cloud storage plans take effect immediately',
  // 获取计划列表
  obtainListOfPlans: 'Obtain a list of plans',
  // 计划价格
  planPrice: 'Plan price',
  // 如果计划是免费的，此字段为空
  ifPlanIsFreeLeaveFieldEmpty: 'If the plan is free, leave this field empty.',
  // 准确到分钟
  accurateToMinutes: 'Accurate to minutes',
  // 向用户显示的计划价格
  planPriceShownToUsers: 'Plan price shown to users',
  // 购买的云存储计划立即生效
  purchasedCloudStoragePlansTakeEffectImmediately:
    'Specify that purchased cloud storage plans take effect immediately',
  // 获取验证码
  getVerificationCode: 'Get verification code',
  // 预登录操作的API
  apisForPreLoginOperations: 'APIs for pre-login operations',
  // 语言
  language: 'Language',
  // 表示中文
  indicatesChinese: 'Indicates Chinese',
  // 表示英文
  indicatesEnglish: 'Indicates English',
  // 国家
  country: 'Country',
  // 表示中国
  indicatesChina: 'Indicates China',
  // 表示美国
  indicatesUnitedStates: 'Indicates the United States',
  // 基于输入字符串的验证码识别目的
  verificationCodeIdentifiesPurpose:
    'The verification code identifies purposes based on input strings.',
  // 设备绑定验证
  deviceBindingVerification: 'Device binding verification',
  // 用户绑定
  userBinding: 'User binding',
  // 更改绑定步骤1
  changeBindingStep1: 'Change binding step 1',
  // 更改绑定步骤2
  changeBindingStep2: 'Change binding step 2',
  // 通过验证码用户登录
  userLoginViaVerificationCode: 'User login via verification code',
  // 通过验证码登录
  loginViaVerificationCode: 'Login via verification code',
  // 访问令牌
  accessToken: 'Access token',
  // 用于刷新访问令牌
  usedToRefreshAccessToken: 'Used to refresh the access token',
  // 刷新令牌
  refreshToken: '’s refresh token',
  // 有效期为半年
  validityPeriodIsHalfYear: 'The validity period is half a year.',
  // 代码验证
  codeVerification: 'Code verification',
  // 一键登录
  oneTapLogin: 'One-tap login',
  // 客户通行证
  clientPass: 'Client pass',
  // 获得一键登录
  obtainedOneTapLogin: 'Obtained one-tap login',
  // 通过
  pass: 'Pass',
  // 更改为
  changeFor: 'Change for',
  // 用户注册
  userRegistration: 'User registration',
  // 商品订单管理模块
  commodityOrderManagementModule: 'Commodity order management module',
  // 查看云存储周期中的天数
  viewNumberOfDaysInCloudStorageCycle: 'View the number of days in a cloud storage cycle',
  // 设备是否使用此类商品
  whetherDeviceIsUsingCommoditiesOfThisCategory:
    'Whether the device is using commodities of this category',
  // 是
  yes: 'Yes',
  // 云存储周期中的天数
  numberOfDaysInACloudStorageCycle: 'Number of days in a cloud storage cycle',
  // 查询为设备购买且准备使用的所有商品
  queryAllCommoditiesPurchasedForDeviceReadyToUse:
    'Query all the commodities that are purchased for the device and are ready to use',
  // 商品使用详情
  commodityUsageDetails: 'Commodity usage details',
  // 商品配置详情
  commodityConfigurationDetails: 'Commodity configuration details',
  // 并激活了第三方系统
  andAThirdPartySystemIsActivated: 'and a third-party system is activated',
  // 但第三方系统的激活失败了
  activationOfThirdPartySystemFailed: 'but the activation of a third-party system failed',
  // 商品信息
  commodityInformation: 'Commodity information',
  // 商品唯一性
  commodityUniqueness: 'Commodity uniqueness',
  // 在外部系统中的设备的唯一标识符
  devicesUniqueIdentifierInExternalSystems: "Device's unique identifier in external systems",
  // 商品租户
  commodityTenant: 'Commodity tenant',
  // 商品内部名称
  commodityInternalName: 'Commodity internal name',
  // 商品外部名称
  commodityExternalName: 'Commodity external name',
  // 商品价格
  commodityPrice: 'Commodity price',
  // 商品显示价格
  commodityDisplayPrice: 'Commodity display price',
  // 准确到元
  accurateToYuan: 'Accurate to Yuan',
  // 结算货币
  currencyOfSettlement: 'Currency of settlement',
  // CNY
  cny: 'CNY',
  // USD或其他
  usdOrOther: 'USD or other',
  // 库存
  inventory: 'Inventory',
  // 商品的类别和规格类型
  commoditysCategoryAndSpecificationType: "Commodity's category and specification type",
  // 类型的类别
  categoryOfType: 'Category of type',
  // 类型名称
  typeName: 'Type name',
  // 此类别支持的规格/属性类型
  specificationTypesSupportedByThisCategory:
    'Specification/property types supported by this category',
  // 规格/属性类型
  specificationPropertyType: 'Specification/property type',
  // 规格/属性类型名称
  specificationPropertyTypeName: 'Specification/property type name',
  // 属性

  // 属性值使用方法
  propertyValueUsageMethod: 'Property value usage method',
  // 显示
  display: 'Display',
  // 购买
  purchase: 'Purchase',
  // 折扣
  discount: 'Discount',
  // 前往商城
  goToMall: 'Go to Mall',
  // 属性详细描述
  propertyDetailedDescription: 'Property detailed description',
  // 属性值数组
  propertyValueArray: 'Property value array',
  // 属性值类别
  propertyValueCategory: 'Property value category',
  // 属性值类型
  propertyValueType: 'Property value type',
  // 商品属性名称
  commodityPropertyName: 'Commodity property name',
  // 商品属性数据
  commodityPropertyData: 'Commodity property data',
  // 商品属性独特性
  commodityPropertyUniqueness: 'Commodity property uniqueness',
  // 商品状态
  commodityStatus: 'Commodity status',
  // 上架
  onShelves: 'On shelves',
  // 下架
  offShelves: 'Off shelves',
  // 商品描述
  commodityDescription: 'Commodity description',
  // 商品图片
  commodityImage: 'Commodity image',
  // 商品数量
  commodityQuantity: 'Commodity quantity',
  // 订单金额
  orderAmount: 'Order amount',
  // 订单创建于
  orderCreatedAt: 'Order created at',
  // 商品消费详情
  commodityConsumptionDetails: 'Commodity consumption details',
  // 查询当前使用的虚拟商品的使用详情
  queryUsageDetailsOfCurrentVirtualCommodities:
    'Query the usage details of the currently used virtual commodities',
  // 查询商品是否有特价
  queryIfCommodityHasSpecialOffers: 'Query whether the commodity has special offers',
  // 是否打折
  whetherAtADiscount: 'Whether at a discount',
  // 商品免费
  commodityFree: 'Commodity free',
  // 折扣名称
  discountName: 'Discount name',
  // 折后价格
  discountedPrice: 'Discounted price',
  // 显示折后价格
  showDiscountedPrice: 'Show discounted price',
  // 原价
  originalPrice: 'Original price',
  // 显示原价
  showOriginalPrice: 'Show original price',
  // 查询订单商品的使用详情
  queryUsageDetailsOfCommodityOfOrder: 'Query the usage details of the commodity of an order',
  // 订单过期前的付款剩余时间
  timeLeftForPaymentBeforeOrderExpiry: 'Time left for payment before order expiry',
  // 查询IoT卡的流量计划详情
  queryTrafficPlanDetailsOfIoTCard: 'Query the traffic plan details of an IoT card',
  // 接入号或
  accessNumberOr: 'Access number or',
  // 商品标识
  commodityIdentifier: 'Commodity identifier',
  // 商品名称
  commodityName: 'Commodity name',
  // 计划开始时间
  planStartTime: 'Plan start time',
  // 计划结束时间
  planEndTime: 'Plan end time',
  // 总金额
  totalAmount: 'Total amount',
  // 余额
  balance: 'Balance',
  // 使用的金额
  amountUsed: 'Amount used',
  // 计划订阅
  planSubscription: 'Plan subscription',
  // 现在使用订单的商品
  useTheCommodityOfOrderNow: 'Use the commodity of an order now',
  // 查询会员详情
  queryMembershipDetails: 'Query membership details',
  // 会员
  member: 'Member',
  // 非会员
  notAMember: 'Not a member',
  // 会员属性详情
  membershipPropertyDetails: 'Membership property details',
  // 该福利的剩余使用次数
  remainingNumberOfUseOfThisBenefit: 'Remaining number of use of this benefit',
  // 商品
  commodity: 'Commodity',
  // 进入商城时指定商品类型
  specifyCommodityTypeWhenEnteringTheMall: 'Specify commodity type when entering the mall',
  // 会员开始时间
  membershipStartTime: 'Membership start time',
  // 获取用户的商品订单列表
  obtainUsersCommodityOrderList: "Obtain the user's commodity order list",
  // 在支付宝中付款所需的字段
  fieldsRequiredForPaymentInAlipay: 'Fields required for payment in Alipay',
  // 在支付宝中的交易ID
  transactionIDInAlipay: 'Transaction ID in Alipay',
  // 获取当前用户的订单统计
  obtainCurrentUsersOrderStats: "Obtain the current user's order stats",
  // 待付款的订单数量
  numberOfOrdersPendingPayment: 'Number of orders pending payment',
  // 已完成的订单数量
  numberOfCompletedOrders: 'Number of completed orders',
  // 取消的订单数量
  numberOfCanceledOrders: 'Number of canceled orders',
  // 模拟付款成功
  simulatedPaymentSuccessful: 'Simulated payment successful',
  // 下单
  orderPlacement: 'Order placement',
  // 设备购买的虚拟服务/商品
  virtualServiceOrCommodityPurchasedForDevice: 'Virtual service/commodity purchased for a device',
  // 购买金额
  purchaseAmount: 'Purchase amount',
  // 页面上默认为一
  oneByDefaultOnThePage: 'One by default on the page',
  // 是否是不需要付款的订单
  whetherAnOrderNotRequiringPayment: 'Whether an order not requiring payment',
  // 下单和付款
  orderPlacementAndPayment: 'Order placement and payment',
  // 如果商品不是为设备购买的虚拟商品，此参数不需要
  ifCommodityIsNotVirtualForDeviceNotRequired:
    'If the commodity is not a virtual commodity purchased for a device, this parameter is not required.',
  // 获取与当前用户商品兼容的产品和设备
  obtainProductsAndDevicesCompatibleWithCurrentUsersCommodity:
    "Obtain the products and devices compatible with the current user's commodity",
  // 基于商品的产品类型
  productTypeBasedOnCommodity: 'Product type Based on commodity',
  // 获取商品详情
  obtainCommodityDetails: 'Obtain commodity details',
  // 商品搜索
  commoditySearch: 'Commodity search',
  // 模糊搜索
  fuzzySearch: 'Fuzzy search',
  // 商品类别
  commodityCategory: 'Commodity category',
  // 支持多值
  multipleValuesSupported: 'Multiple values supported',
  // 云存储增值类别
  cloudStorageValueAddingCategory: 'Cloud storage value-adding category',
  // 流量类别
  trafficCategory: 'Traffic category',
  // CiNMOORE会员类别
  ciNMOOREMembershipCategory: 'CiNMOORE membership category',
  // 商品支持的产品类型
  productTypesSupportedByTheCommodity: 'Product types supported by the commodity',
  // 虚拟商品介绍
  virtualCommodityIntroduction: 'Virtual commodity introduction',
  // 标识类别
  identificationCategory: 'Identification category',
  // 接受设备分享
  acceptDeviceSharing: 'Accept device sharing',
  // 需要邀请码
  anInvitationCodeIsRequired: 'An invitation code is required.',
  // 公共类别
  publicCategory: 'Public category',
  // 邀请码
  invitationCode: 'Invitation code',
  // 分享记录
  sharingRecords: 'Sharing records',
  // 警报统计
  alertStats: 'Alert stats',
  // 警报
  alert: 'Alert',
  // 电池电量统计
  batteryLevelStats: 'Battery level stats',
  // 如果是从用户角度显示统计
  statsAreDisplayedFromUserPerspective: 'stats are displayed from the user perspective',
  // 报警数量
  alarmQuantity: 'Alarm quantity',
  // 警报类型
  alertType: 'Alert type',
  // 警报名称
  alertName: 'Alert name',
  // 报告详细页面
  reportDetailsPage: '-day security report',

  // 警告数量
  alertQuantity: 'Alert quantity',

  // 警告数据趋势
  alertDataTrend: 'Alert data trend',

  // 天数据
  dayData: '-day data',

  // 日期
  dateInfo: 'Date',

  // 数量
  quantity: 'Quantity',

  // 绑定设备
  bindDevice: 'Bind device',

  // 查询用户的设备和云存储
  queryUsersDevicesAndCloudStorage: "Query user's devices and cloud storage",

  // 消息页面
  messagesPage: 'Messages page',

  // 设备管理
  deviceManagement: 'Device management',

  // 云存储周期中的天数
  numberOfDaysInCloudStorageCycle: 'Number of days in a cloud storage cycle',

  // 设备来源
  deviceSource: 'Device source',

  // 用户设备列表
  userDeviceList: 'User device list',

  // 空
  emptyStatus: 'Empty',

  // 查询所有设备
  queryAllDevices: 'Query all devices',

  // 绑定类型
  bindingType: 'Binding type',

  // 如果此参数未指定，它表示
  ifParameterNotSpecified: 'If this parameter is not specified, it indicates',

  // 产品中的所有设备
  allDevicesOfProduct: 'All devices',

  // 产品中自主开发设备所属的
  selfDevelopedDeviceOfProduct: 'of the product to which the self-developed device belongs',

  // 自主开发设备ID
  selfDevelopedDeviceId: 'Self-developed device ID',

  // 设备型号
  deviceModel: 'Device model',

  // 自主开发设备状态
  selfDevelopedDeviceStatus: 'Self-developed device status',

  // 设备开机/关机
  devicePowerOnOff: 'Device power-on/off',

  // 电池电量详情页
  batteryLevelDetailsPage: 'Battery level details page',

  // 唤醒
  wakeUp: 'Wake-up',

  // 天设备电池状态
  dayDeviceBatteryStats: '-day device battery stats',

  // Y轴
  yAxis: 'Y-axis',

  // X轴
  xAxis: 'X-axis',

  // 警告类型列表
  alertTypeList: 'Alert type list',

  // 查询设备信息
  queryDeviceInfo: 'Query device information',

  // 设备产品的
  deviceProducts: 'Device product’s',

  // 产品内设备的唯一标识符
  devicesUniqueIdentifierWithinProduct: "Device's unique identifier within product",

  // 设备默认名称
  deviceDefaultName: 'Device default name',

  // 查询设备连接状态
  queryDeviceConnectionStatus: 'Query device connection status',

  // 获取设备设置和配置
  obtainDeviceSettingsAndConfigurations: 'Obtain device settings and configurations',

  // 配置类型
  configurationType: 'Configuration type',

  // 标识配置
  identifiesConfiguration: 'Identifies a configuration',

  // 设备设置页面
  deviceSettingsPage: 'Device settings page',

  // 高级设置
  advancedSettings: 'Advanced settings',

  // 设备详情
  deviceDetails: 'Device details',

  // 工作模式
  workingMode: 'Working mode',

  // 配置信息
  configurationInformation: 'Configuration information',

  // 设备的组
  devicesGroup: 'Device’s group',

  // 分享设备
  shareDevice: 'Share device',

  // 设备编号
  deviceSerialNumber: 'SN',

  // 电话号码或电子邮件地址
  phoneNumberOrEmailAddress: 'Phone number or email address',

  // 奇数内
  oddNumbersWithin: 'Odd numbers within',

  // 用户收到的邀请列表
  usersListReceivedInvitations: "User's list received invitations",

  // 总条目
  totalEntries: 'Total entries',

  // 每页的条目数量
  numberOfEntriesPerPage: 'Number of entries per page',

  // 邀请记录
  invitationRecords: 'Invitation records',

  // 分享设备的用户名
  usernameWhoSharedDevice: 'Username of whoever shared the device',

  // 共享设备
  sharedDeviceStatus: 'Shared device',

  // 状态
  statusInfo: 'Status',

  // 待添加
  toBeAdded: 'To be added',

  // 已添加
  addedStatus: 'Added',

  // 拒绝添加
  rejectToAdd: 'Reject to add',

  // 解绑设备
  unbindDevice: 'Unbind device',

  // 取消共享设备
  unshareDevice: 'Unshare device',

  // 表示设备共享者已取消共享
  indicatesDeviceSharerCanceledSharing:
    'Indicates that who shared the device has canceled the sharing',

  // 表示共享已被设备共享者取消
  sharingCanceledByDeviceSharer:
    'Indicates that the sharing has been canceled by who shared the device',

  // 修改设备信息
  modifyDeviceInfo: 'Modify device information',

  // 设备封面图片URL
  deviceCoverImageUrl: 'Device cover image URL',

  // 用户登录
  userLogin: 'User login',

  // 取消成功
  cancelSuccess: 'Cancel Success',

  // 取消权限分享
  cancelPermissionSharing: "Are you sure to cancel {userName}'s sharing?",

  deleteSuccess: 'Delete Success',

  // 请设置权限
  pleaseSetPermissions: 'Please set {userName} permissions',

  validPeriod: 'Valid period: ',
  validPeriodConnector: ' to ',
  pleaseEnterVerificationCode: 'Please enter the verification code',
  pleaseEnterValidVerificationCode: 'Please enter a valid verification code',
  pleaseEnterTransferAccount: 'Please enter a phone number or email address',
  enterAccount: 'Enter the other party’s account',
  transferAccountDesc: 'To ensure your rights, please ensure that the account you enter is correct',
  verifyAccountTitle: 'Verify account',
  verifyAccountDesc: 'The verification code will be sent to ',
  pleaseEnterValidEmailOrPhone: 'Please enter a valid phone number or email',
  shareQRTitle: 'Share the other party to receive the device',
  shareQRDesc:
    'Please have the other party log in to the {account} of the CiNMOORE account to complete the reception by scanning the QR code',
  saveScreenshot: 'Save image',
  shareQR: 'Share with the other party',
  resendCode: 'Resend',
  sendCode: 'Send verification code',
  canTransferRights: 'Can transfer rights',
  unTransferRights: 'Cannot transfer rights',
  deviceAlreadyShared: 'Device sharing cannot be transferred',
  deviceAlreadySharedContent: 'Please cancel the sharing and try again',
  goHandle: 'Go to settings',
  verifyCodeError: 'The verification code is wrong, please re-enter',
  deviceAlreadyOffline: 'Device already offline',
  stopTransferTitle: 'Are you sure to stop the transfer',
  stopTransferContent: 'After stopping the transfer, the QR code generated will be invalid',
  stopTransfer: 'Stop transfer',
  qrCodeExpired: 'QR code expired',
  qrCodeValidity: 'QR code validity: ',
  useAppScan: 'Use the app to scan and receive the device',
  useAppScanDesc: 'Please log in to the {account} of the app account to complete the reception',
  noContent: 'No content',
  transferDeviceAnnouncement: 'Transfer device announcement',
  transferDeviceConfirm: 'You are transferring the device, please confirm the following:',
  pleaseEnterAccount: 'Please enter the other party’s account',
  selectShareMethod: 'Select share method',
  transferDeviceAndRightsService: '转移说明',
  transferDeviceAndRightsService1: '1、若设备正在分享中，无法转移；',
  transferDeviceAndRightsService2:
    '2、若设备已开通云存储等可以转移的增值服务，相应的服务也会转移；若开通了订阅服务，将取消订阅服务，次月不再扣费续订；',
  transferDeviceAndRightsService3:
    '3、转移时若设备不在线，设备已开通的增值服务转移过去可能是关闭状态',
  transferDeviceAndRightsService4:
    '4、设备的消息、云录像、人脸库等记录仍保留在原账号下，按原有机制清理；',
  transferDeviceAndRightsService5: '5、设备本地保存的所有人脸数据将被清',
  generateKeyError: "The account is not registered in app, can't transfer the device",

  'Pir.title': 'PIR Infrared Detector',
  'Pir.desc1':
    'PIR: Commonly known as a Passive Infrared Detector or Body Sensor; it triggers camera alarms and recording by absorbing the infrared heat from human bodies and pets.',
  'Pir.desc2':
    'Since infrared signals can be affected by scenarios like glass obstruction, object blocking, and increased environmental temperatures, it is recommended to turn off the PIR infrared detector in situations where there is glass obstruction or increased environmental temperatures.',
  'Pir.desc3': 'Below is a schematic diagram of the PIR infrared detector location:',

  'profileForSF.account': 'Account',
  'profileForSF.tryAgain': 'Try Again',
  'profileForSF.shareUser': 'Shared Users',
  'profileForSF.sharedAccessRequests': 'Shared Access Requests',
  'profileForSF.checkForUpdates': 'Check for Updates',
  'profileForSF.userAgreement': 'User Agreement',
  'profileForSF.privacyPolicy': 'Privacy Policy',
  'profileForSF.languageSetting': 'Language',
  'profileForSF.help': 'Help',
  'profileForSF.about': 'About',
  'profileForSF.logOut': 'Log Out',
  'profileForSF.about.unknowVersion': 'unknow version',
  'profileForSF.titleAppVersiontitleAppVersion': 'APP VERSION',
  'profileForSF.titleFirmwareVersion': 'FIRMWARE VERSION',
  'profileForSF.checkVersionFail':
    'Failed to check the device version. (Possible causes: device is offline, disconnected from the network, or powered off.) ',
  accountSettingsForSF: 'Account Settings',
  'accountSettingsForSF.name': 'Name',
  'accountSettingsForSF.edit': 'Edit',
  'accountSettingsForSF.email': 'Email',
  'accountSettingsForSF.twoStepVerification': 'Two Step Verification',
  'accountSettingsForSF.changePassword': 'Change Password',
  'accountSettingsForSF.deleteAccount': 'Delete Account',
  'accountSettingsForSF.addPhoneNumber': 'Add Phone Number',

  'accountSettingsForSF.editEmail': 'Edit Email',
  'accountSettingsForSF.errorEmailEmpty': "Email can't be empty",
  'accountSettingsForSF.emailFormatIncorrect': 'Email format is incorrect',
  'accountSettingsForSF.placeholderEmail': 'ex. xxx@gmail.com',
  'accountSettingsForSF.noChange': 'No Change',

  'accountSettingsForSF.editUserName': 'Edit User Name',
  'accountSettingsForSF.placeholderUserName': 'ex. jack',

  'accountSettingsForSF.phoneNumber': 'Phone Number',
  'accountSettingsForSF.placeholderPhoneNumber': 'ex. Phone Number',
  'accountSettingsForSF.areaCode': 'Country Code',
  'accountSettingsForSF.editPhoneNumber': 'Edit Phone Number',
  'accountSettingsForSF.areaCodeEmpty': 'Area Code cannot be empty',

  'accountSettingsForSF.passwordNotSame': 'Confirm Password not the same as New Password',
  'accountSettingsForSF.passwordIsSame': 'Old password and new password cannot be the same',
  'accountSettingsForSF.oldPassword': 'Old Password',
  'accountSettingsForSF.newPassword': 'New Password',
  'accountSettingsForSF.newPasswordConfirm': 'Confirm New Password',
  'accountSettingsForSF.placeholderPassword': 'ex. Password',
  'accountSettingsForSF.updatePassword': 'Update Password',

  'accountSettingsForSF.addSharedUser': 'Add Shared User',
  'accountSettingsForSF.addSharedMemberSuccess': 'Add shared member successfully',
  'accountSettingsForSF.relationshipToUser': 'Relationship To User',
  'accountSettingsForSF.placeholderRelationshipToUser': 'ex. Friend',
  'accountSettingsForSF.sharedWithNewUser': 'Shared With New User',
  'accountSettingsForSF.accountISharedWith': 'ACCOUNT I SHARED WITH',
  'accountSettingsForSF.device': 'Device',

  'accountSettingsForSF.sharedUser': 'Shared User',
  'accountSettingsForSF.deleteSuccess': 'Delete Success',
  'accountSettingsForSF.update': 'Update',
  'accountSettingsForSF.updateSuccess': 'Update Success',
  'accountSettingsForSF.noDevice': 'No device',
  'accountSettingsForSF.noDeviceCanShared': 'No device can shared',
  'accountSettingsForSF.deleteSharedUser': 'Delete Shared User',
  'accountSettingsForSF.deleteSharedDoubleContent':
    'This action cannot be undone. Are you sure you want to delete this?',
  'accountSettingsForSF.deleteSharedDoubleTitle': 'Confirm deletion?',
  'accountSettingsForSF.waitingForA': 'Waiting for acceptance',
  'accountSettingsForSF.acceptedTm': 'Accepted',

  'groupEdit.realDelete1': 'Are you sure you want to delete',
  'groupEdit.realDelete2': ' Group?',
  pleaseEnterEmail: 'Enter Email Address',
  pleaseEnterPassword: 'Enter your password',
  loginAgreement: 'I have read and agree to {loginAgreementService} and {loginAgreementPolicy}',
  loginAgreementService: 'Terms of Service',
  loginAgreementPolicy: 'Privacy Policy',
  validEmail: 'Please enter the correct email',
  agree: 'Accept',
  reject: 'Reject',
  alexaAgreementTitle: 'After logging in Alexa will gain the following privileges',
  alexaAgreementContent:
    '· Access your Cinmoore account {br} · Use the Cinmoore account to control and view the camera',

  verifyEmptyError: ' Cannot be empty',
  verifyEmojiError: ' Cannot contain emojis',
  verifyMaxLenError: ' Cannot exceed {max} characters',
  verifyEmojiMaxLenError: ' Cannot contain emojis and cannot exceed {max} characters',
};
